import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router";
import {
  logoutEstudiosTurnos,
  wsPostTurnosEstudios,
  wsPostTomarTurnoEstudios,
} from "../../context/Actions/turnos/estudioTurnos";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import {
  logoutConsultaMedTurnos,
  wsPostConsultaMedTurnos,
  wsPostTomarTurnoConsultaMed,
} from "../../context/Actions/turnos/consultaMedTurnos";
import {
  logoutLaboTurnos,
  setBuscarTurnoLabo,
  setFlgCambiarTurno,
  wsGetLaboTurnos,
  wsPostTomarTurnoLaboratorio,
  wsPutCambiarTurnoLaboratorio,
} from "../../context/Actions/turnos/laboTurnos";
import {
  editaTurnosDisponibles,
  finalizaTurnosDisponibles,
  resetFiltrosDisponibles,
  setFechaTurno,
} from "../../context/Actions/turnos/turnosDisponibles";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import EtiquetaGrupoModal from "../../components/Turnos/EtiquetaGrupoModal/EtiquetaGrupoModal";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { logicaTomarTurno, esDtoEstudiosValido } from "./TomarTurnoLogica";
import { SetUserProximoTurno } from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import {
  guardarTipoTurno,
  guardarUltimoTurno,
  limpiarDatosMedico,
  limpiarTipoTurno,
  limpiarUltimoTurno,
  resetIdTurnoSolicitud,
} from "../../context/Actions/turnos/turnosPaciente";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import "./TurnosDisponibles.css";
import { logoutMultiTab } from "../../context/Actions/multiTab/logoutMultiTab";
import { loginTokenReset } from "../../context/Actions/token/loginToken";
import { GlobalContext } from "../../../global/context/Provider";
import { PortalContext } from "../../context/Provider";
import { getHoraString } from "../../../global/utils/getHoraString";
import { getDiaString } from "../../../global/utils/getDiaString";
import camelize from "../../../global/utils/camelize";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import ViewIcon from "../../assets/images/generico/ViewIcon";
import ConsultaIcon from "../../assets/images/generico/ConsultaIcon";
import { setUsuarioAuth } from "../../../global/context/action/auth/login";
import fechaTurnoFormat2 from "global/utils/fechaTurnoFormat2";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { resetLabOrdenDigital } from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import {
  BodyTurnosDisponibles,
  EspecialidadBox,
  EtiquetaContainer,
  FechaBusqBox,
  FiltroBox,
  FiltroEtiqueta,
  FiltrosAplicadosBox,
  FiltrosContainer,
  FlechaContainer,
  InfoContainer,
  InfoFiltrosBox,
  InformacionTurnosBox,
  LineSep,
  MasTurnosBox,
  MasTurnosBtn,
  PacienteBox,
  TurnosDisponiblesBox,
  TurnosDisponiblesContainer,
} from "./styles/localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import CardTurnoFiltro2 from "_+_Portal/components/Turnos/CardTurnoFiltro/CardTurnoFiltro2";
import FiltrosTD from "_+_Portal/components/Turnos/FiltrosTD/FiltrosTD";
import HeaderbarHome from "_+_Portal/components/Genericos/HeaderbarHome/HeaderbarHome";
import { isMobile } from "react-device-detect";
import FiltroIcon from "_+_Portal/assets/images/generico/FiltroIcon";
import SearchPlusIcon from "_+_Portal/assets/images/generico/SearchPlusIcon";
import CruzEtiqueta from "_+_Portal/assets/images/generico/CruzEtiqueta";
import FlechaDropdown from "_+_Portal/assets/images/generico/FlechaDropdown";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import BurguerMobile from "_+_Portal/components/Genericos/BurguerMobile/BurguerMobile";

const TurnosDisponibles2 = () => {
  const {
    modalState,
    modalDispatch,
    estudioTurnosDispatch,
    estudioTurnosState,
    consultaMedTurnosState,
    consultaMedTurnosDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    laboTurnosState,
    laboTurnosDispatch,
    ayudaDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    turnosPacienteDispatch,
    multiTabDispatch,
    tokenState,
    tokenDispatch,
    textosState,
    labOrdenDigitalState,
    labOrdenDigitalDispatch,
    ordenDigitalState,
    ordenDigitalDispatch,
  } = useContext(PortalContext);

  const {
    authState,
    authDispatch,
    toasterDispatch,
    toasterState,
    configState,
  } = useContext(GlobalContext);

  const [descEspecialidad, setDescEspecialidad] = useState(false);
  const [grupoMedicoOk, setGrupoMedicoOk] = useState(false);
  const [agrupaEtiqueta, setAgrupaEtiqueta] = useState(false);
  const [dtoNuevaBusqueda, setDtoNuevaBusqueda] = useState();
  const [flgNuevaBusqueda, setFlgNuevaBusqueda] = useState(false);
  const [fechaBusqueda, setFechaBusqueda] = useState();
  const [turnosOriginal, setTurnosOriginal] = useState();
  const [onChangeDate, setOnChangeDate] = useState("");
  const [etiquetaPart, setEtiquetaPart] = useState(false);
  const [busquedaDatePicker, setBusquedaDatePicker] = useState(false);
  const [flgExcedeBusq, setFlgExcedeBusq] = useState(false);
  const [excedeBusqMsj, setExcedeBusqMsj] = useState(false);
  const [flgModalExcedeBusq, setFlgModalExcedeBusq] = useState(false);
  const [load, setLoad] = useState(true);
  const [widthWindow, setWidthWindow] = useState(window.innerWidth);
  const [flgBusquedaTurnosLoading, setFlgBusquedaTurnosLoading] =
    useState(false);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [visibleCards, setVisibleCards] = useState([]);
  const [filtros, setFiltros] = useState(
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
  );
  const [filtrosAplicados, setFiltrosAplicados] = useState([]);
  const [showFiltros, setShowFiltros] = useState(false);
  const [fechaOriginal, setFechaOriginal] = useState(null);
  const [especialistasOriginal, setEspecialistasOriginal] = useState(null);
  const [checkboxData, setCheckboxData] = useState(null);
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const cardsPerPage = 15;
  let scrollPage = 1;
  const arrxTurnosScroll = useRef([]);
  const visibleLength = useRef(0);

  const history = useHistory();
  const fecha = new Date();
  let accion = sessionStorage.getItem("accionHash");
  let config = localStorage.getItem("config");
  let opcBuscadorTurnos = JSON.parse(config).opcBuscadorTurnos;
  useEffect(() => {
    const handleResize = () => {
      setWidthWindow(window.innerWidth);
    };

    // Agrega el listener de resize cuando el componente se monta
    window.addEventListener("resize", handleResize);

    // Limpia el listener cuando el componente se desmonta
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fechaBuscandoHasta = new Date(
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda,
  );

  const handleClickVolver = () => {
    if (ordenDigitalState.ordenDigital.flgVolver) {
      resetOrdenDigitalEstudio()(ordenDigitalDispatch);
      history.push("/ordenesDigitales");
    } else {
      history.goBack();
    }
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    logoutLaboTurnos()(laboTurnosDispatch);
    limpiarUltimoTurno()(turnosPacienteDispatch);
    limpiarTipoTurno()(turnosPacienteDispatch);
    logoutMultiTab()(multiTabDispatch);
    loginTokenReset()(tokenDispatch);
    resetLabOrdenDigital()(labOrdenDigitalDispatch);
    setUsuarioAuth({
      ...authState.auth.data,
      idProtocolo: null,
      accionToken: null,
    })(authDispatch);
    finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickShowDeterminaciones = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Tus turnos agregados",
        texto: <EtiquetaGrupoModal />,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Continuar",
          clase: "btn-Mensaje-1 bgc-black10 cursor:pointer rb18m c-white",
          accion: dissmiss,
        },
      ],
      "centro",
    )(modalDispatch);
  };

  const handleChangeDatePicker = (e) => {
    if (e !== null) {
      setOnChangeDate(e);
      setFechaTurno(e)(turnosDisponiblesDispatch);
      setBusquedaDatePicker(true);
      filtrarTurnos(turnosOriginal);
    }
  };

  useEffect(() => {
    completarEspecialistasCentros(
      turnosDisponiblesState?.turnosDisponibles?.turnosData?.turnos,
    );
    resetIdTurnoSolicitud()(turnosPacienteDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    //eslint-disable-next-line
  }, []);

  //cambio la fecha y escucho el cambio para enviarle la fecha correcta
  useEffect(() => {
    if (onChangeDate !== "") {
      onClickProximosTurnos();
      setOnChangeDate("");
    }
    //eslint-disable-next-line
  }, [onChangeDate]);

  // Controla los checks de centros
  const handleChangeCentros = (centroArrx) => {
    let origenLabo =
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO";
    if (origenLabo) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    } else {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centros: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    }
  };

  //este useEffect filtra cuando se desmarco algun item del filtro.
  useEffect(() => {
    if (turnosOriginal !== undefined) {
      filtrarTurnos(turnosOriginal);
    }
    //eslint-disable-next-line
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData]);

  const filtrarTurnos = (turnos) => {
    // defino una lista aux para filtrar siempre por el mismo resultado.
    if (turnos !== undefined) {
      // ------------------ ZONA EN LA QUE SE FITRAN LOS CENTROS ------------------------
      let auxCentro = null;
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "LABORATORIO"
      ) {
        let centrosLabo =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo;

        auxCentro = centrosLabo.filter(
          (centro) =>
            centro.checked !== false &&
            centro.descripcion !== "Todos los centros",
        );

        if (auxCentro.length === 0) {
          auxCentro = centrosLabo.filter(
            (centros) => centros.descripcion !== "Todos los centros",
          );
        }
      } else {
        let centros =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centros;

        auxCentro = centros.filter(
          (centro) =>
            centro.checked !== false &&
            centro.descripcion !== "Todos los centros",
        );

        // Si estan todos los dias desmarcados muestro todo
        if (auxCentro.length === 0) {
          auxCentro = centros.filter(
            (centros) => centros.descripcion !== "Todos los centros",
          );
        }
      }
      // ------------------ ZONA EN LA QUE SE FITRAN LOS ESPECIALISTAS ------------------------
      let especialistas =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .especialistas;
      let auxEsp = especialistas.filter(
        (especialista) =>
          especialista.checked !== false &&
          especialista.descripcion !== "Todos",
      );

      // Si estan todos los dias desmarcados muestro todo
      if (auxEsp.length === 0) {
        auxEsp = especialistas.filter(
          (especialista) => especialista.descripcion !== "Todos",
        );
      }

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS DIAS ------------------------
      let dias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin;
      let auxDiaSem = dias.filter(
        (dia) => dia.checked !== false && dia.descripcion !== "Todos",
      );
      // Si estan todos los dias desmarcados muestro todo
      if (auxDiaSem.length === 0) {
        auxDiaSem = dias.filter((dias) => dias.descripcion !== "Todos");
      }

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS RANGOS ------------------------
      let rangos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoHorario;

      let auxRango = rangos.filter(
        (rango) => rango.checked !== false && rango.descripcion !== "Todos",
      );
      // Si estan todos los dias desmarcados muestro todo
      if (auxRango.length === 0) {
        auxRango = rangos.filter((rango) => rango.descripcion !== "Todos");
      }

      // ------------------ LA ZONA EN LA QUE SE FITRAN QUE SE DEJAN LAS DESC EN EL ARRAY ------------------------
      auxCentro = auxCentro.map((array) => array.descripcion);
      auxEsp = auxEsp.map((array) => array.descripcion);
      auxDiaSem = auxDiaSem.map((array) => array.descripcion);

      let turnoFiltrado = null;
      let turnoFiltradoAux1 = turnos.filter(
        (item) =>
          // auxCentro.includes(item.centro) &&
          auxCentro.includes(item.centro) &&
          auxEsp.includes(
            item.medico !== null
              ? camelize(item.medico)
              : camelize(item.recepcion),
          ) &&
          auxDiaSem.includes(getDiaString(item.fecha)),
      );

      if (auxRango.length > 0) {
        for (let i = 0; i < auxRango.length; i++) {
          let turnoFiltradoAux2 = turnoFiltradoAux1.filter(
            (item) =>
              getHoraString(item.hora) >= auxRango[i].horaMin &&
              getHoraString(item.hora) < auxRango[i].horaMax,
          );
          if (i === 0) {
            turnoFiltrado = turnoFiltradoAux2;
          } else {
            turnoFiltrado = turnoFiltrado.concat(turnoFiltradoAux2);
          }
        }
      } else {
        turnoFiltrado = [];
      }


      turnoFiltrado = turnoFiltrado.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.fecha) - new Date(b.fecha);
      });

      setTurnosDisponibles(turnoFiltrado);
      setVisibleCards(turnoFiltrado.slice(0, cardsPerPage));
    }
  };

  let turnosScroll =
    document.documentElement.getElementsByClassName("bodyTurnos");

  // Detecta cuando llegamos al final del scroll y carga más cards
  const handleScroll = () => {
    if (
      turnosScroll[0].scrollTop + turnosScroll[0].clientHeight >=
      turnosScroll[0].scrollHeight
    ) {
      loadMoreCards(arrxTurnosScroll);
    }
  };

  const loadMoreCards = (cards) => {
    const nextPage = scrollPage + 1;
    const startIndex = scrollPage * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;

    if (startIndex < cards?.current?.length) {
      const newCards = cards?.current.slice(startIndex, endIndex);
      setVisibleCards((prevCards) => [...prevCards, ...newCards]);
      scrollPage = nextPage;
      visibleLength.current = cards?.current.length;
    }
  };

  useEffect(() => {
    turnosScroll[0].addEventListener("scroll", handleScroll);
    return () => {
      if (turnosScroll[0]) {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    arrxTurnosScroll.current = turnosDisponibles;
  }, [turnosDisponibles]);

  // useEffect(() => {
  //   arrxTurnosScroll.current =
  //     turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
  // }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  const handleChangeDia = (diaSemArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: diaSemArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeRango = (rangoArrx) => {
    // este editar lo deja vacio sin editar.
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        rangoHorario: rangoArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeEspecialista = (espArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        especialistas: espArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const nextStepTurno = (isCorrect, data) => {
    if (isCorrect) {
      logoutEstudiosTurnos()(estudioTurnosDispatch);
      logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      logoutLaboTurnos()(laboTurnosDispatch);
      resetFiltrosDisponibles()(turnosDisponiblesDispatch); // Este reset da problemas
      finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      logoutMultiTab()(multiTabDispatch);
      setFlgCambiarTurno(false)(laboTurnosDispatch);
      setBuscarTurnoLabo(false)(laboTurnosDispatch);
      resetOrdenDigitalEstudio()(ordenDigitalDispatch);
      // limpiar idProtocolo que viene del token
      setUsuarioAuth({
        ...authState.auth.data,
        idProtocolo: null,
        accionToken: null,
      })(authDispatch);
      if (accion) {
        sessionStorage.removeItem("accionHash");
      }
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData?.dtoBusqueda
          ?.videoAtencion
      ) {
        history.push("/videoConsulta");
      } else {
        history.push("/turnoReservado");
      }
    } else {
      if (
        data.detail !== "" &&
        data.detail !== null &&
        data.detail !== undefined
      ) {
        if (data.detail.length > 100) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: data.detail,
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: dissmiss,
              },
            ],
            "centro",
          )(modalDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        } else {
          showToaster(
            {
              texto: data.detail,
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      } else {
        showToaster(
          {
            texto: "Error al tomar el turno",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    }
  };

  const handleOnClickConfirmar = (turnoSeleccionado) => {
    setFlgBusquedaTurnosLoading(true);
    const turnoDto = {
      idTurno: turnoSeleccionado.idturno,
      medico: turnoSeleccionado.medico,
      centro: turnoSeleccionado.centro,
      ubicacion: turnoSeleccionado.ubicacion,
      hora: turnoSeleccionado.hora,
      fecha: turnoSeleccionado.fecha,
      especialidad: turnoSeleccionado.especialidad,
      idTurnoCombinadoturno: turnoSeleccionado.idTurnoCombinadoturno,
    };

    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "estudios"
    ) {
      // ESTUDIOS
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "ESTUDIOS",
        dtoNuevaBusqueda,
      ).dto;
      // Red de seguridad: si otra instancia del buscador pisó el estado compartido,
      // el DTO llega con GruposMedico[].Id vacío y el backend lo rechaza con 400.
      // Mejor avisar y mandar al paciente a buscar de nuevo.
      if (!esDtoEstudiosValido(dto)) {
        setFlgBusquedaTurnosLoading(false);
        showToaster(
          {
            texto:
              "Se perdió la búsqueda del turno. Volvé a buscarlo para confirmarlo.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        if (opcBuscadorTurnos && widthWindow > 1024) {
          history.push("/buscadorTurnos");
        } else if (
          turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
          "CONSULTA_MEDICA"
        ) {
          history.push("/consultamedica");
        } else {
          history.push("/estudios");
        }
        return;
      }
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "ESTUDIOS",
        dtoNuevaBusqueda,
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      guardarUltimoTurno(dto.idTurno)(turnosPacienteDispatch);
      guardarTipoTurno({
        tipo: "ESTUDIO",
        estudio:
          turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio,
        circuito: turnosDisponiblesState.turnosDisponibles.turnosData.circuito,
      })(turnosPacienteDispatch);
      wsPostTomarTurnoEstudios(
        dto,
        idFamiliar,
        nextStepTurno,
      )(estudioTurnosDispatch);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
      "consMedica"
    ) {
      // CONSULTA MEDICA
      // La lógica de esta parte está dentro de la función
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "CONSULTA_MEDICA",
      ).dto;
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "CONSULTA_MEDICA",
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      guardarUltimoTurno(dto.idTurno)(turnosPacienteDispatch);
      guardarTipoTurno({ tipo: "CONSULTA", estudio: dto.descripcion })(
        turnosPacienteDispatch,
      );
      wsPostTomarTurnoConsultaMed(
        dto,
        idFamiliar,
        nextStepTurno,
      )(consultaMedTurnosDispatch);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo" &&
      tokenState.token.data === null &&
      !labOrdenDigitalState.labOrdenDigital.altaTurno
    ) {
      // LABORATORIO
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "LABORATORIO",
        dtoNuevaBusqueda,
        authState?.auth?.data?.idProtocolo > 0 &&
        authState?.auth?.data?.idProtocolo,
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.dtoBusqueda
          ?.OsAlternativa,
      ).dto;
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        configState,
        "LABORATORIO",
        dtoNuevaBusqueda,
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.dtoBusqueda
          ?.OsAlternativa,
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
      guardarTipoTurno({ tipo: "LABO", estudio: "" })(turnosPacienteDispatch);
      wsPostTomarTurnoLaboratorio(
        dto,
        idFamiliar,
        nextStepTurno,
      )(laboTurnosDispatch);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo" &&
      (tokenState.token.data !== null ||
        labOrdenDigitalState.labOrdenDigital.altaTurno)
    ) {
      // LABORATORIO CON LINK
      if (
        tokenState.token.data?.idProtocolo !== "-1" &&
        tokenState.token.data?.idProtocolo !== null &&
        tokenState.token.data?.idProtocolo !== undefined
      ) {
        const dto = logicaTomarTurno(
          turnosDisponiblesState,
          ordenDigitalState,
          turnoDto,
          selectDropDownState,
          authState,
          configState,
          "LABORATORIO",
          dtoNuevaBusqueda,
          tokenState.token.data?.idProtocolo,
        ).dto;
        const idFamiliar = -1;
        guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
        guardarTipoTurno({ tipo: "LABO", estudio: "" })(turnosPacienteDispatch);
        wsPostTomarTurnoLaboratorio(
          dto,
          idFamiliar,
          nextStepTurno,
        )(laboTurnosDispatch);
      } else {
        // LABORATORIO DESDE ORDENES DIGITALES
        if (labOrdenDigitalState.labOrdenDigital.altaTurno) {
          const dto = logicaTomarTurno(
            turnosDisponiblesState,
            ordenDigitalState,
            turnoDto,
            selectDropDownState,
            authState,
            configState,
            "LABORATORIO",
            dtoNuevaBusqueda,
            labOrdenDigitalState.labOrdenDigital.altaTurno,
          ).dto;
          const idFamiliar = logicaTomarTurno(
            turnosDisponiblesState,
            ordenDigitalState,
            turnoDto,
            selectDropDownState,
            authState,
            configState,
            "LABORATORIO",
            dtoNuevaBusqueda,
            labOrdenDigitalState.labOrdenDigital.altaTurno,
          ).idFamiliar;
          guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
          resetLabOrdenDigital()(labOrdenDigitalDispatch);
          guardarTipoTurno({ tipo: "LABO", estudio: "" })(
            turnosPacienteDispatch,
          );
          if (laboTurnosState.laboTurnos.flgCambiarTurno) {
            wsPutCambiarTurnoLaboratorio(
              turnoDto.idTurno,
              labOrdenDigitalState.labOrdenDigital.altaTurno,
              idFamiliar ? idFamiliar : -1,
              nextStepTurno,
            )(laboTurnosDispatch);
          } else {
            wsPostTomarTurnoLaboratorio(
              dto,
              idFamiliar,
              nextStepTurno,
            )(laboTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: "Error al tomar el turno",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }
      }
      // }
    } else {
      showToaster(
        {
          texto: "Error al tomar el turno",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  // useEffect(() => {
  //   if (confimoTurno) {
  //     if (
  //       laboTurnosState.laboTurnos.data === true ||
  //       estudioTurnosState.estudioTurnos.data === "" ||
  //       consultaMedTurnosState.consultaMedTurnos.data > 100 ||
  //       (laboTurnosState.laboTurnos.data !== null &&
  //         laboTurnosState.laboTurnos.data !== undefined &&
  //         laboTurnosState.laboTurnos.data.hora > 1)
  //     ) {
  //       logoutEstudiosTurnos()(estudioTurnosDispatch);
  //       logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  //       logoutLaboTurnos()(laboTurnosDispatch);
  //       resetFiltrosDisponibles()(turnosDisponiblesDispatch); // Este reset da problemas
  //       finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  //       logoutMultiTab()(multiTabDispatch);
  //       setFlgCambiarTurno(false)(laboTurnosDispatch);
  //       setBuscarTurnoLabo(false)(laboTurnosDispatch);
  //       resetOrdenDigitalEstudio()(ordenDigitalDispatch);
  //       // limpiar idProtocolo que viene del token
  //       setUsuarioAuth({
  //         ...authState.auth.data,
  //         idProtocolo: null,
  //         accionToken: null,
  //       })(authDispatch);
  //       if (accion) {
  //         sessionStorage.removeItem("accionHash");
  //       }
  //       if (
  //         turnosDisponiblesState.turnosDisponibles.turnosData?.dtoBusqueda
  //           ?.videoAtencion
  //       ) {
  //         history.push("/videoConsulta");
  //       } else {
  //         history.push("/proximosTurnos");
  //       }
  //       setConfirmoTurno(false);
  //     } else if (
  //       (estudioTurnosState.estudioTurnos.error !== false &&
  //         estudioTurnosState.estudioTurnos.data !== null) ||
  //       (consultaMedTurnosState.consultaMedTurnos.error !== false &&
  //         consultaMedTurnosState.consultaMedTurnos.error !== null) ||
  //       (laboTurnosState.laboTurnos.error !== false &&
  //         laboTurnosState.laboTurnos.error !== null)
  //     ) {
  //       if (estudioTurnosState.estudioTurnos.error !== null) {
  //         if (
  //           estudioTurnosState.estudioTurnos.error.detail !== "" &&
  //           estudioTurnosState.estudioTurnos.error.detail !== null &&
  //           estudioTurnosState.estudioTurnos.error.detail !== undefined
  //         ) {
  //           if (estudioTurnosState.estudioTurnos.error.detail.length > 100) {
  //             showModal(
  //               "Genericos/Mensaje/Mensaje",
  //               {
  //                 titulo: "Atención",
  //                 texto: estudioTurnosState.estudioTurnos.error.detail,
  //                 dissmiss: dissmiss,
  //                 danger: true,
  //               },
  //               [
  //                 {
  //                   text: "Volver",
  //                   clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
  //                   accion: dissmiss,
  //                 },
  //               ],
  //               "centro"
  //             )(modalDispatch);
  //             logoutEstudiosTurnos()(estudioTurnosDispatch);
  //           } else {
  //             showToaster(
  //               {
  //                 texto: estudioTurnosState.estudioTurnos.error.detail,
  //                 tipo: "danger",
  //               },
  //               "centroArriba"
  //             )(toasterDispatch);
  //             logoutEstudiosTurnos()(estudioTurnosDispatch);
  //           }
  //         } else {
  //           showToaster(
  //             {
  //               texto: "Error al tomar el turno",
  //               tipo: "danger",
  //             },
  //             "centroArriba"
  //           )(toasterDispatch);
  //         }
  //       } else if (consultaMedTurnosState.consultaMedTurnos.error !== null) {
  //         if (
  //           consultaMedTurnosState.consultaMedTurnos.error.detail.length > 100
  //         ) {
  //           showModal(
  //             "Genericos/Mensaje/Mensaje",
  //             {
  //               titulo: "Atención",
  //               texto: consultaMedTurnosState.consultaMedTurnos.error.detail,
  //               dissmiss: dissmiss,
  //               danger: true,
  //             },
  //             [
  //               {
  //                 text: "Volver",
  //                 clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
  //                 accion: dissmiss,
  //               },
  //             ],
  //             "centro"
  //           )(modalDispatch);
  //           logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  //         } else {
  //           showToaster(
  //             {
  //               texto: consultaMedTurnosState.consultaMedTurnos.error.detail,
  //               tipo: "danger",
  //             },
  //             "centroArriba"
  //           )(toasterDispatch);
  //           logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  //         }
  //         setFlgBusquedaTurnosLoading(false);
  //       } else {
  //         showToaster(
  //           {
  //             texto: "Error al tomar el turno",
  //             tipo: "danger",
  //           },
  //           "centroArriba"
  //         )(toasterDispatch);
  //         setFlgBusquedaTurnosLoading(false);
  //       }
  //     }
  //   }
  //   //eslint-disable-next-line
  // }, [estudioTurnosState, consultaMedTurnosState, laboTurnosState]);

  // const onClickFiltrosMobile = () => {
  //   showModal(
  //     "Turnos/FiltrosTurnos/FiltrosTurnos",
  //     {
  //       titulo: "Filtrar turnos",
  //       dissmiss: dissmiss,
  //       handleClickBuscar: dissmiss,
  //       handleClickProximos: onClickProximosTurnos,
  //       handleChangeDatePicker: handleChangeDatePicker,
  //       flgExcedeBusq: flgExcedeBusq,
  //       fecha: fecha,
  //     },
  //     [],
  //     "centro"
  //   )(modalDispatch);
  // };

  const onClickFiltrosMobile = () => {
    showModal(
      "Turnos/FiltrosTurnos/FiltrosTurnos2",
      {
        titulo: "Filtrar turnos",
        dissmiss: dissmiss,
        handleClickBuscar: dissmiss,
        handleClickProximos: onClickProximosTurnos,
        handleChangeDatePicker: handleChangeDatePicker,
        flgExcedeBusq: flgExcedeBusq,
        fecha: fecha,
        filtros: filtros,
        filtrosData:
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        filtrosAplicados: filtrosAplicados,
        setFiltrosAplicados: setFiltrosAplicados,
        handleChangeCentros: handleChangeCentros,
        handleChangeDia: handleChangeDia,
        handleChangeRango: handleChangeRango,
        handleChangeEspecialista: handleChangeEspecialista,
        setShowFiltros: setShowFiltros,
        checkboxData: checkboxData,
        setCheckboxData: setCheckboxData,
      },
      [],
      "centro",
    )(modalDispatch);
  };

  //HAY QUE MEJORAR Y PREPARAR LA LOGICA PARA TODAS LAS BUSQUEDAS DESDE ACA.
  const onClickProximosTurnos = () => {
    dissmiss();
    let fechaSliced =
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda.slice(
        0,
        -9,
      );
    if (onChangeDate !== "") {
      fechaSliced = onChangeDate;
    }
    setFlgNuevaBusqueda(true);
    //revisar esto
    setDtoNuevaBusqueda({
      ...dtoNuevaBusqueda,
      fechaDesde: fechaSliced,
    });
    setFechaBusqueda(fechaSliced);
    //lo limpio para que cuando use esta funcion sin el filtro fecha, obtenga le fecha deseada.
    setOnChangeDate("");
  };

  const dissmissReinciarBusq = () => {
    setFlgModalExcedeBusq(false);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (flgNuevaBusqueda) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
        "estudios"
      ) {
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsPostTurnosEstudios(
            dtoNuevaBusqueda,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            (isCorrect, data) => actualizarTurnos(isCorrect, data, "ESTUDIO"),
          )(estudioTurnosDispatch);
        } else {
          wsPostTurnosEstudios(dtoNuevaBusqueda, -1, (isCorrect, data) =>
            actualizarTurnos(isCorrect, data, "ESTUDIO"),
          )(estudioTurnosDispatch);
        }
      } else if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
        "consMedica"
      ) {
        wsPostConsultaMedTurnos(
          dtoNuevaBusqueda.especialidad,
          dtoNuevaBusqueda.medico,
          fechaBusqueda,
          dtoNuevaBusqueda.flgEspecialidadPart,
          dtoNuevaBusqueda.videoConsulta,
          -1,
          false,
          (isCorrect, data) => actualizarTurnos(isCorrect, data, "CONSULTA"),
        )(consultaMedTurnosDispatch);
      } else if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo"
      ) {
        wsGetLaboTurnos(
          fechaBusqueda,
          -1,
          -1,
          dtoNuevaBusqueda.idGrupo,
          -1,
          (isCorrect, data) => actualizarTurnos(isCorrect, data, "LABO"),
        )(laboTurnosDispatch);
      }
    }
    //eslint-disable-next-line
  }, [dtoNuevaBusqueda]);

  const actualizarTurnos = (isCorrect, data, tipo) => {
    if (isCorrect) {
      let arrayTurnos = null;
      let auxFecha = "";
      if (tipo === "ESTUDIO") {
        let turnosAux1 =
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
        let turnosAux2 = data.turnos;
        let turnosAux3 = turnosAux1.concat(turnosAux2);

        // En caso de buscar por datepicker ingresa a este if y filtra los turnos mayores al dia seleccionado
        // hasta 7 dias adelante. Tambien borra los turnos que son anteriores a la fecha seleccionada
        if (
          busquedaDatePicker &&
          turnosDisponiblesState.turnosDisponibles.turnosData
            .fechaSeleccionada !== false
        ) {
          const fechaInicial = new Date(
            turnosDisponiblesState.turnosDisponibles.turnosData
              .fechaSeleccionada,
          );
          // Sumar 7 días a la fecha inicial
          const fechaNueva = new Date(fechaInicial);
          fechaNueva.setDate(fechaInicial.getDate() + 8);

          let arrx = [];
          for (let i = 0; i < turnosAux3.length; i++) {
            const element = turnosAux3[i];
            if (
              new Date(element.fecha) <= fechaNueva &&
              new Date(element.fecha) >= fechaInicial
            ) {
              arrx.push(element);
            }
          }
          turnosAux3 = arrx;
        }

        let aux4 = turnosAux3.filter(
          (v, i, a) => a.findIndex((v2) => v2.idturno === v.idturno) === i,
        );

        //REVISAR AGREGADO
        if (data.msjFechaLimite === null) {
          auxFecha = data.fechaBusqueda;
        }
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: aux4,
          fechaBusqueda: auxFecha,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(aux4);
        setTurnosOriginal(aux4);
        arrayTurnos = aux4;

        if (busquedaDatePicker) {
          let body = document.getElementsByClassName("bodyTurnos")[0];
          if (body) body.scrollTop = 0;
        } else {
          let arrayE = [];
          var turnoScroll = "";

          if (!estudioTurnosState.estudioTurnos.loading) {
            const lastElement = turnosAux1[turnosAux1.length - 1];
            arrayE.push(lastElement);
            turnoScroll = lastElement;
          }

          if (
            turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
          ) {
            scrollTest(turnoScroll.idturno);
          }
        }
        if (
          data.turnos.length === 0 &&
          data.msjFechaLimite !== null &&
          !flgExcedeBusq
        ) {
          let mensaje = data.msjFechaLimite.descripcion;

          //accion cuando ya no tengo turnos.
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(mensaje);
          if (aux4.length > 0) {
            //mensaje cuando ya tenia turnos.
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: mensaje,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro",
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
        setBusquedaDatePicker(false);
        completarEspecialistasCentros(aux4);
      } else if (tipo === "CONSULTA") {
        let turnosAux1 =
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
        let turnosAux2 = data.data;
        let turnosAux3 = turnosAux1.concat(turnosAux2);

        if (
          busquedaDatePicker &&
          turnosDisponiblesState.turnosDisponibles.turnosData
            .fechaSeleccionada !== false
        ) {
          const fechaInicial = new Date(
            turnosDisponiblesState.turnosDisponibles.turnosData
              .fechaSeleccionada,
          );
          const fechaNueva = new Date(fechaInicial);
          fechaNueva.setDate(fechaInicial.getDate() + 8);

          turnosAux3 = turnosAux3.filter(
            (element) =>
              new Date(element.fecha) >= fechaInicial &&
              new Date(element.fecha) <= fechaNueva,
          );
        }

        let aux4 = turnosAux3.filter(
          (v, i, a) => a.findIndex((v2) => v2.idturno === v.idturno) === i,
        );

        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: aux4,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(aux4);
        setTurnosOriginal(aux4);
        arrayTurnos = aux4;

        if (busquedaDatePicker) {
          let body = document.getElementsByClassName("bodyTurnos")[0];
          if (body) body.scrollTop = 0;
        } else {
          let arrayE = [];
          var turnoConsScroll = "";

          if (!estudioTurnosState.estudioTurnos.loading) {
            const lastElement = turnosAux1[turnosAux1.length - 1];
            arrayE.push(lastElement);
            turnoConsScroll = lastElement;
          }

          if (
            turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
          ) {
            scrollTest(turnoConsScroll.idturno);
          }
        }
        //activoFlg msjBusqFechaLimite
        if (data.data.length === 0 && data.msjFechaLimite !== null) {
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(data.msjFechaLimite.descripcion);
          if (turnosAux3.length > 0) {
            //mensaje cuando ya tenia turnos.
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: data.msjFechaLimite.descripcion,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro",
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
        setBusquedaDatePicker(false);
        completarEspecialistasCentros(aux4);
      } else {
        let turnosAnteriores =
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.data,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(data.data);
        setTurnosOriginal(data.data);
        arrayTurnos = data.data;

        if (data.data.length === 0 && data.msjFechaLimite !== null) {
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(data.msjFechaLimite.descripcion);
          if (turnosAnteriores?.length > 0) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: data.msjFechaLimite.descripcion,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro",
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
        completarEspecialistasCentros(data.data);
      }
      filtrarTurnos(arrayTurnos);
    }
  };

  const reiniciaBusquedaModal = () => {
    setFlgModalExcedeBusq(true);
    setFlgExcedeBusq(false);
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      turnos: [],
      fechaBusqueda: fechaTurnoFormat2(),
    })(turnosDisponiblesDispatch);
    setTurnosDisponibles([]);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  };

  useEffect(() => {
    if (flgModalExcedeBusq) {
      setFlgModalExcedeBusq(false);
      dissmiss();
      onClickProximosTurnos();
    }
  }, [flgModalExcedeBusq]);

  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos === null) {
      if (opcBuscadorTurnos && widthWindow > 1024) {
        history.push("/buscadorTurnos");
      } else {
        history.push("/consultamedica");
      }
      // este fix de consultamedica y los signos de pregunta"?" que se ven en las asignaciones luego
      // del return son para que no pinche si apretamos f5
    } else {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        "" &&
        turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        null
      ) {
        setDescEspecialidad(true);
      }
      setEtiquetaPart(
        turnosDisponiblesState.turnosDisponibles.turnosData.particular,
      );
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico !==
        null
      ) {
        setGrupoMedicoOk(true);
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico
            .length > 1
        ) {
          setAgrupaEtiqueta(true);
          setEtiquetaPart(false);
        } else {
          if (
            turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico[0]
              .particular
          ) {
            setEtiquetaPart(true);
          }
        }
      }
      setTurnosOriginal(
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos,
      );
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
        "LABORATORIO"
      ) {
        setTurnosDisponibles(
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos,
        );
        setVisibleCards(
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.slice(
            0,
            cardsPerPage,
          ),
        );
      }
      setDtoNuevaBusqueda(
        turnosDisponiblesState.turnosDisponibles.turnosData.dtoBusqueda,
      );
      setLoad(false);
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }

    return () => {
      loginTokenReset()(tokenDispatch);
    };
    //eslint-disable-next-line
  }, []);

  // const [testRef, setTestRef] = useState();

  const myRef = useRef({});

  const scrollTest = (e) => {
    let id = myRef.current[e];
    if (
      id !== null &&
      !estudioTurnosState.estudioTurnos.loading &&
      !consultaMedTurnosState.consultaMedTurnos.loading &&
      !laboTurnosState.laboTurnos.loading
    ) {
      id?.scrollIntoView({ behavior: "smooth", block: "center" });
      id?.focus();
    }
  };

  const completarEspecialistasCentros = (data) => {
    if (data?.length > 0) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
        "LABORATORIO"
      ) {
        let centro = [...new Set(data.map((item) => item.centro))];
        const map = new Map();
        for (const item of centro) {
          if (
            !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.filter(
              (x) => x.descripcion === item,
            ).length > 0
          ) {
            if (!map.has(item)) {
              map.set(item);
              //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
              const lastItem =
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                  .centros[
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .filtrosData.centros.length - 1
                ];
              if (lastItem) {
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.push(
                  {
                    id: lastItem.id + 1,
                    descripcion: item,
                    checked: false,
                  },
                );
              }
            }
          }
        }
      }

      let especialistas = [
        ...new Set(
          data.map((item) =>
            item.medico !== null ? item.medico : item.recepcion,
          ),
        ),
      ];
      const mapEsp = new Map();
      for (const item of especialistas) {
        if (
          !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.filter(
            (x) => camelize(x.descripcion) === camelize(item),
          ).length > 0
        ) {
          if (!mapEsp.has(item)) {
            mapEsp.set(item);
            const lastItem =
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .especialistas[
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .especialistas.length - 1
              ];
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.push(
              {
                id: lastItem.id + 1,
                descripcion: camelize(item),
                checked: false,
              },
            );
          }
        }
      }
      const diasSinTodos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData?.diasKin.filter(
          (item) => item.descripcion !== "Todos",
        );
      const rangoSinTodos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData?.rangoHorario.filter(
          (item) => item.descripcion !== "Todos",
        );
      const espSinTodos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData?.especialistas.filter(
          (item) => item.descripcion !== "Todos",
        );
      let centrosSinTodos = [];
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
        "LABORATORIO"
      ) {
        centrosSinTodos =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData?.centros.filter(
            (item) => item.descripcion !== "Todos los centros",
          );
      } else {
        centrosSinTodos =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData?.centrosLabo.filter(
            (item) => item.descripcion !== "Todos los centros",
          );
      }

      setFiltros((prevFiltros) => ({
        ...prevFiltros, // Conserva las propiedades actuales
        diasKin: diasSinTodos,
        rangoHorario: rangoSinTodos,
        centros: centrosSinTodos,
        especialistas: espSinTodos,
      }));
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "LABORATORIO"
      ) {
        let objFilter = {
          diasKin: diasSinTodos,
          rangoHorario: rangoSinTodos,
          centros: centrosSinTodos,
          especialistas: espSinTodos,
        };

        // Recorre cada propiedad del objeto
        Object.values(objFilter).forEach((item) => {
          // Verifica si 'item' es un array antes de continuar
          if (Array.isArray(item)) {
            // Filtra los elementos con 'checked === true'
            const itemsChecked = item.filter((u) => u.checked);

            // Agrega a filtrosAplicados si no existen duplicados por 'descripcion'
            setFiltrosAplicados((prev) => [
              ...prev.filter(
                (f) =>
                  !itemsChecked.some((u) => u.descripcion === f.descripcion),
              ),
              ...itemsChecked,
            ]);
          }
        });

        filtrarTurnos(data);
      }
    }
  };

  const onChangeFilter = () => {
    setShowFiltros(!showFiltros);
  };

  const onChangeEtiquetas = (item) => {
    const { descripcion, id } = item;
    let nuevosFiltros = filtrosAplicados.filter(
      (filtro) => filtro.descripcion !== descripcion,
    );
    setFiltrosAplicados(nuevosFiltros);

    if (nuevosFiltros.length === 0) {
      setShowFiltros(false);
    }
    // Desmarcar el checkbox correspondiente
    const categoria = getCheckboxCategory(item); // Función que determina la categoría
    if (categoria) {
      const newCheckboxData = checkboxData[categoria].map((checkbox) =>
        checkbox.id === id ? { ...checkbox, checked: false } : checkbox,
      );
      setCheckboxData((prev) => ({ ...prev, [categoria]: newCheckboxData }));
      if (categoria === "diasKin") {
        handleChangeDia(newCheckboxData);
      } else if (categoria === "rangoHorario") {
        handleChangeRango(newCheckboxData);
      } else if (categoria === "centros") {
        handleChangeCentros(newCheckboxData);
      } else if (categoria === "especialistas") {
        handleChangeEspecialista(newCheckboxData);
        setEspecialistasOriginal(newCheckboxData);
      }
    }
    if (item.fecha) {
      handleChangeDatePicker(fechaOriginal);
    }
  };

  const getCheckboxCategory = (item) => {
    let filtrosData = filtros;
    if (filtrosData?.centros.some((i) => i.descripcion === item.descripcion))
      return "centros";
    if (filtrosData?.diasKin.some((i) => i.descripcion === item.descripcion))
      return "diasKin";
    if (
      filtrosData?.rangoHorario.some((i) => i.descripcion === item.descripcion)
    )
      return "rangoHorario";
    if (
      filtrosData?.especialistas.some((i) => i.descripcion === item.descripcion)
    )
      return "especialistas";
    return null;
  };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  // useEffect para setear la fecha inicial y en caso de sacar el filtro de fecha
  // que vuelva a buscar por dicha fecha inicial
  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada) {
      setFechaOriginal(
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada,
      );
    } else {
      setFechaOriginal(
        `${fecha.getFullYear()}-${fecha.getMonth() + 1 >= 10
          ? fecha.getMonth() + 1
          : `0${fecha.getMonth() + 1}`
        }-${fecha.getDate() >= 10 ? fecha.getDate() : `0${fecha.getDate()}`}`,
      );
    }
  }, []);

  useEffect(() => {
    setShowFiltros(() => showFiltros && filtrosAplicados?.length > 0);
  }, [filtrosAplicados]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={
          estudioTurnosState.estudioTurnos.loading ||
          consultaMedTurnosState.consultaMedTurnos.loading ||
          laboTurnosState.laboTurnos.loading
        }
        color="c-white"
        descripcion={
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading ||
            laboTurnosState.laboTurnos.loading) &&
            flgBusquedaTurnosLoading &&
            "Tomando turno...") ||
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading ||
            laboTurnosState.laboTurnos.loading) &&
            !flgBusquedaTurnosLoading &&
            "Buscando turnos...")
        }
      />
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome
        turnos={true}
        onShowBurguerHandle={onShowBurguerHandle}
        handleClickVolver={handleClickVolver}
      />
      <TurnosDisponiblesContainer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          opacity: [0, 0.3, 0.7, 1],
          times: [0, 0.3, 0.7, 1],
        }}
      >
        <FiltrosContainer className="c-white">
          <FiltrosTD
            handleChangeDatePicker={handleChangeDatePicker}
            handleChangeCentros={handleChangeCentros}
            handleChangeDia={handleChangeDia}
            handleChangeRango={handleChangeRango}
            handleChangeEspecialista={handleChangeEspecialista}
            filtrosData={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            }
            fecha={fecha}
            filtros={filtros}
            filtrosAplicados={filtrosAplicados}
            setFiltrosAplicados={setFiltrosAplicados}
            checkboxData={checkboxData}
            setCheckboxData={setCheckboxData}
            onChangeEtiquetas={onChangeEtiquetas}
            especialistasOriginal={especialistasOriginal}
            setEspecialistasOriginal={setEspecialistasOriginal}
          />
        </FiltrosContainer>
        <InformacionTurnosBox>
          <InfoContainer $mobile={isMobile}>
            {isMobile ? (
              <>
                <MasTurnosBox onClick={onClickProximosTurnos}>
                  <SearchPlusIcon size={20} />
                  <p className="c-latex30 rb16mh">Más turnos</p>
                </MasTurnosBox>
                <LineSep />
                <FiltroBox onClick={onClickFiltrosMobile}>
                  <FiltroIcon size={22} />
                  <p className="c-latex30 rb16mh">Filtros</p>
                </FiltroBox>
              </>
            ) : (
              <>
                <EtiquetaContainer>
                  <ConsultaIcon color={"var(--color-white)"} />
                  {etiquetaPart ? (
                    <span className="c-white rb14b">PARTICULAR:</span>
                  ) : (
                    ""
                  )}
                  <span className="c-white rb14l">
                    {grupoMedicoOk ? (
                      agrupaEtiqueta ? (
                        <button
                          onClick={() => onClickShowDeterminaciones()}
                          className="ptur-turnosAgregados-cancelarBtn c-white"
                        >
                          VER ESTUDIOS AGREGADOS
                          <span className="">
                            <ViewIcon />
                          </span>
                        </button>
                      ) : descEspecialidad ? (
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .descEspecialidad
                      ) : (
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .descEstudio
                      )
                    ) : descEspecialidad ? (
                      turnosDisponiblesState.turnosDisponibles.turnosData
                        .descEspecialidad
                    ) : (
                      turnosDisponiblesState.turnosDisponibles.turnosData
                        .descEstudio
                    )}
                  </span>
                </EtiquetaContainer>
                <PacienteBox>
                  <p className="rb16m">
                    {" "}
                    <span style={{ marginRight: "10px" }}>Para:</span>
                    {turnosDisponiblesState.turnosDisponibles.turnosData
                      .volverOrigen === "CONSULTA_MEDICA"
                      ? !selectDropDownState.selectDropDown.selectGlobal
                        .pacienteElegido
                        ? camelize(authState.auth.data.paciente.nombre)
                        : camelize(
                          selectDropDownState.selectDropDown.selectGlobal
                            .pacienteElegido.paciente.nombre,
                        )
                      : turnosDisponiblesState.turnosDisponibles.turnosData
                        .volverOrigen === "ESTUDIOS"
                        ? !selectDropDownState.selectDropDown.selectGlobal
                          .pacienteElegido
                          ? camelize(authState.auth.data.paciente.nombre)
                          : camelize(
                            selectDropDownState.selectDropDown.selectGlobal
                              .pacienteElegido.paciente.nombre,
                          )
                        : turnosDisponiblesState.turnosDisponibles.turnosData
                          .volverOrigen === "LABORATORIO"
                          ? !selectDropDownState.selectDropDown.selectGlobal
                            .pacienteElegido
                            ? camelize(authState.auth.data.paciente.nombre)
                            : camelize(
                              selectDropDownState.selectDropDown.selectGlobal
                                .pacienteElegido.paciente.nombre,
                            )
                          : camelize(authState.auth.data.paciente.nombre)}
                  </p>
                </PacienteBox>
                {!flgExcedeBusq ? (
                  <FechaBusqBox className="rb16m">
                    <span style={{ marginRight: "10px" }}>
                      Fecha de búsqueda hasta:
                    </span>
                    {turnosDisponiblesState.turnosDisponibles.turnosData
                      .fechaBusqueda === ""
                      ? ""
                      : turnosDisponiblesState.turnosDisponibles.turnosData
                        .volverOrigen === "CONSULTA_MEDICA"
                        ? turnosDisponiblesState.turnosDisponibles.turnosData
                          .volverOrigen === "ESTUDIOS"
                          ? `${fechaBuscandoHasta.getDate()}/${fechaBuscandoHasta.getMonth() + 1
                          }/${fechaBuscandoHasta.getFullYear()}`
                          : `${fechaBuscandoHasta.getDate()}/${fechaBuscandoHasta.getMonth() + 1
                          }/${fechaBuscandoHasta.getFullYear()}`
                        : `${fechaBuscandoHasta.getDate()}/${fechaBuscandoHasta.getMonth() + 1
                        }/${fechaBuscandoHasta.getFullYear()}`}
                  </FechaBusqBox>
                ) : (
                  ""
                )}
                {!flgExcedeBusq && (
                  <MasTurnosBtn
                    onClick={onClickProximosTurnos}
                    className="anchoDisable600Max"
                  >
                    Buscar más turnos
                  </MasTurnosBtn>
                )}
              </>
            )}
          </InfoContainer>
          {isMobile && (
            <InfoFiltrosBox>
              <EspecialidadBox>
                <div className="especialidad-container">
                  <span className="espTxt c-latex30 rb14m">
                    Para:{" "}
                    {turnosDisponiblesState.turnosDisponibles.turnosData
                      .volverOrigen === "CONSULTA_MEDICA"
                      ? !selectDropDownState.selectDropDown.selectGlobal
                          .pacienteElegido
                        ? camelize(authState.auth.data.paciente.nombre)
                        : camelize(
                            selectDropDownState.selectDropDown.selectGlobal
                              .pacienteElegido.paciente.nombre,
                          )
                      : turnosDisponiblesState.turnosDisponibles.turnosData
                            .volverOrigen === "ESTUDIOS"
                        ? !selectDropDownState.selectDropDown.selectGlobal
                            .pacienteElegido
                          ? camelize(authState.auth.data.paciente.nombre)
                          : camelize(
                              selectDropDownState.selectDropDown.selectGlobal
                                .pacienteElegido.paciente.nombre,
                            )
                        : turnosDisponiblesState.turnosDisponibles.turnosData
                              .volverOrigen === "LABORATORIO"
                          ? !selectDropDownState.selectDropDown.selectGlobal
                              .pacienteElegido
                            ? camelize(authState.auth.data.paciente.nombre)
                            : camelize(
                                selectDropDownState.selectDropDown.selectGlobal
                                  .pacienteElegido.paciente.nombre,
                              )
                          : camelize(authState.auth.data.paciente.nombre)}
                  </span>
                </div>
              </EspecialidadBox>
              <EspecialidadBox>
                <div className="especialidad-container">
                  <ConsultaIcon
                    color={"var(--color-latex30)"}
                    width={18}
                    height={18}
                  />
                  {etiquetaPart ? (
                    <span className="c-latex30 rb14b">PARTICULAR:</span>
                  ) : (
                    ""
                  )}
                  <span className="espTxt c-latex30 rb14m">
                    {grupoMedicoOk ? (
                      agrupaEtiqueta ? (
                        <button
                          onClick={() => onClickShowDeterminaciones()}
                          className="ptur-turnosAgregados-cancelarBtn c-latex30"
                        >
                          VER ESTUDIOS AGREGADOS
                          <span className="">
                            <ViewIcon />
                          </span>
                        </button>
                      ) : descEspecialidad ? (
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .descEspecialidad
                      ) : (
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .descEstudio
                      )
                    ) : descEspecialidad ? (
                      turnosDisponiblesState.turnosDisponibles.turnosData
                        .descEspecialidad
                    ) : (
                      turnosDisponiblesState.turnosDisponibles.turnosData
                        .descEstudio
                    )}
                  </span>
                </div>
                {filtrosAplicados?.length > 0 &&
                  <FlechaContainer
                    onClick={onChangeFilter}
                    $rotate={showFiltros ? 1 : 0}
                  >
                    <FlechaDropdown color={"var(--color-latex30)"} />
                  </FlechaContainer>
                }
              </EspecialidadBox>
              <FiltrosAplicadosBox $showFiltros={showFiltros}>
                {showFiltros &&
                  filtrosAplicados?.map((item, index) => {
                    return (
                      <FiltroEtiqueta
                        className="rb14l c-white"
                        key={index}
                        onClick={() => onChangeEtiquetas(item)}
                      >
                        {item.descripcion}
                        <div
                          className="cruzBox pointer"
                        // onClick={() => onChangeEtiquetas(item)}
                        >
                          <CruzEtiqueta color={"var(--color-white)"} />
                        </div>
                      </FiltroEtiqueta>
                    );
                  })}
              </FiltrosAplicadosBox>
            </InfoFiltrosBox>
          )}

          <BodyTurnosDisponibles className="bodyTurnos">
            {!load && (
              <TurnosDisponiblesBox
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 1.5,
                  ease: "easeInOut",
                  opacity: [0, 0.3, 0.7, 1],
                  times: [0, 0.3, 0.7, 1],
                }}
              >
                {turnosDisponibles.length === 0 ? (
                  <>
                    <TurnoNoEncontrado
                      excedeBusqMsj={excedeBusqMsj}
                      excedeBusqueda={flgExcedeBusq}
                      state={turnosDisponibles}
                      loadingState={turnosDisponiblesState.turnosDisponibles}
                      texto={textosState.textos.data?.msjSinTurnoDisponible?.nombre.slice(
                        0,
                        -7,
                      )}
                      recomendacion={
                        textosState.textos.data?.msjSinTurnoDisponible
                          ?.descripcion
                      }
                      fecha={new Date(
                        turnosDisponiblesState.turnosDisponibles.turnosData
                          .fechaBusqueda,
                      ).toLocaleDateString("es-AR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                      txtBtn={
                        !flgExcedeBusq
                          ? "Proximos turnos disponibles"
                          : "Reiniciar Búsqueda"
                      }
                      onClickTurnos={onClickProximosTurnos}
                      showBtn={true}
                    />
                  </>
                ) : widthWindow < 1024 ? (
                  visibleCards.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div
                          ref={(el) => (myRef.current[item.idturno] = el)}
                          id={item.idturno}
                        >
                          <CardTurnoFiltro2
                            handleOnClickConfirmar={() =>
                              handleOnClickConfirmar(item)
                            }
                            idTurno={item.idturno}
                            medico={camelize(
                              item.medico !== null ? item.medico : "",
                            )}
                            centro={item.centro}
                            ubicacion={item.ubicacion}
                            coordenadaGps={item.coordenadaGps}
                            hora={item.hora}
                            fecha={item.fecha}
                            especialidad={
                              item.especialidad !== null
                                ? camelize(item.especialidad)
                                : ""
                            }
                            proceso={
                              turnosDisponiblesState.turnosDisponibles
                                ?.turnosData?.proceso
                            }
                          />
                        </div>
                      </React.Fragment>
                    );
                  })
                ) : (
                  turnosDisponibles.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div
                          ref={(el) => (myRef.current[item.idturno] = el)}
                          id={item.idturno}
                        >
                          <CardTurnoFiltro2
                            handleOnClickConfirmar={() =>
                              handleOnClickConfirmar(item)
                            }
                            idTurno={item.idturno}
                            medico={camelize(
                              item.medico !== null ? item.medico : "",
                            )}
                            centro={item.centro}
                            ubicacion={item.ubicacion}
                            coordenadaGps={item.coordenadaGps}
                            hora={item.hora}
                            fecha={item.fecha}
                            especialidad={
                              item.especialidad !== null
                                ? camelize(item.especialidad)
                                : ""
                            }
                            proceso={
                              turnosDisponiblesState.turnosDisponibles
                                ?.turnosData?.proceso
                            }
                          />
                        </div>
                      </React.Fragment>
                    );
                  })
                )}
              </TurnosDisponiblesBox>
            )}

            {estudioTurnosState.estudioTurnos.loading ||
              consultaMedTurnosState.consultaMedTurnos.loading ||
              laboTurnosState.laboTurnos.loading
              ? ""
              : turnosDisponibles.length > 12 && (
                <FloatingScroll body={"bodyTurnos"} />
              )}

            <div className="footerHelpTurnosDisp"></div>
          </BodyTurnosDisponibles>
        </InformacionTurnosBox>
      </TurnosDisponiblesContainer>
    </React.Fragment>
  );
};

export default TurnosDisponibles2;
